import type { RouteOptimizationResult } from '../entities/RouteOptimizationResult.js';
import { dedupeDepotStops } from './dedupeDepotStops.js';

export function getTotalServiceTime(
  stops: Array<NonNullable<RouteOptimizationResult['routes'][number]['stops']>[number]> | undefined,
): number {
  const dedupedDepotStops = dedupeDepotStops(stops?.filter(stop => stop.type === 'depot') ?? []);
  if (!stops) return 0;
  return (
    stops.reduce((sum, stop) => sum + (stop.type === 'depot' ? 0 : (stop.serviceDurationMinutes ?? 0)), 0) +
    dedupedDepotStops.length * 15
  ); // depot stops use a flat 15 minutes of service time per unique depot, their own serviceDurationMinutes is ignored
}
